"use client";

import { c as _c } from "react/compiler-runtime";
import CollapsibleSection from "@/components/ui/collapsible-section";
import { Skeleton } from "@/components/ui/skeleton";
import { useModule } from "@/hooks/use-module";
import type { PatientDetail } from "@/types/patient";
import { WearableDeviceList, WearableSendLinkButton, WearableSyncButton, useWearableDevices } from "./wearable-devices";
interface DevicesSectionProps {
  patient: PatientDetail;
}
export default function DevicesSection(props) {
  const $ = _c(2);
  const wearablesEnabled = useModule("WEARABLES");
  if (!wearablesEnabled) {
    return null;
  }
  let t0;
  if ($[0] !== props) {
    t0 = <DevicesSectionContent {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function DevicesSectionContent(t0) {
  const $ = _c(13);
  const {
    patient
  } = t0;
  const devices = useWearableDevices(patient.id, true);
  const {
    connections
  } = devices;
  let t1;
  if ($[0] !== devices) {
    t1 = <WearableSyncButton devices={devices} />;
    $[0] = devices;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== patient) {
    t2 = <WearableSendLinkButton patient={patient} />;
    $[2] = patient;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== connections || $[8] !== devices) {
    t4 = !connections ? <div className="space-y-2"><Skeleton className="h-16 w-full rounded-lg" /></div> : connections.length === 0 ? <div className="py-8 text-center"><p className="text-body text-foreground-secondary">No devices connected</p><p className="mt-1 text-caption text-foreground-muted">Send this patient a link to connect their wearable, and their readings will start appearing on their chart.</p></div> : <WearableDeviceList devices={devices} />;
    $[7] = connections;
    $[8] = devices;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <CollapsibleSection title="Devices" persistKey="devices-overview" actions={t3}>{t4}</CollapsibleSection>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}